/** Class representing an upload error.
 * This error will be thrown upon any http error in the uploading process
 *  @extends Error
 */
export default class RemoteActionError extends Error {

    /**
     * Create an UploadError
     * @param {number|string} status - http status code
     * @param {string} statusText
     * @param {UploadErrorTypes} type
     */
    constructor(status, statusText, type) {
        super(statusText);
        this.type = type;
        this.status = status;
    }
}
